module.exports = __webpack_public_path__ + "static/media/plusCircle-green.23d27594.svg";


//////////////////
// WEBPACK FOOTER
// ./src/resources/icons/plusCircle-green.svg
// module id = 1064
// module chunks = 0